<div class="d-flex flex-column gap-4">
    <div class="page-title">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xxl" (click)="backHandler()"></i>
        </button>
        {{'asset.assetJourney' | translate}}
    </div>

    <!-- Asset Header -->
    <div *ngIf="dataLoaded" class="d-flex gap-3 mb-1">
        <!-- First part: Asset name and buttons -->
        <div class="col-6 col-lg-4 d-flex flex-column gap-2">
            <div id="Name">
                <span HJSuppress class="asset-name">{{asset.assetName}}</span>
            </div>
            <div class="d-flex flex-column gap-3">
                <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED">
                    <span placement="end" tooltipClass="request-warning-tooltip opacity-100">
                        <button
                            *ngIf="asset.isContractActive && asset.dictionaryContractType.code !== ContractType.CREDIT"
                            class="btn outline-btn"
                            [ngbTooltip]="requestAccessWarnings.length > 0 ? warningMessagesTemplate : null"
                            tooltipClass="request-warning-tooltip opacity-100"
                            (click)="redirectDocumentRequest(asset.contractExternalEntityId, asset.assetId)"
                            [disabled]="requestAccessWarnings.length > 0"
                        >
                            {{'contractDetail.assets.documentRequest' | translate}}
                        </button>
                    </span>
                </div>
                <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.ESTIMATED">
                    <div class="d-flex align-items-center justify-content-start">
                        <div class="badge badge-delivery-state state-estimated d-flex align-items-center gap-1">
                            <div class="circle-box">
                                <div class="circle-box-inner"></div>
                            </div>
                            {{'contractDetail.assets.deliveryStatus.' + asset.deliveryStatus | translate}}:
                            {{ asset.deliveryDate ? (asset.deliveryDate | localizedDate) : '' }}
                        </div>
                    </div>
                </div>
                <div HJSuppress *ngIf="asset.lastInspectionDate || asset.nextInspectionDate">
                    <div *ngIf="asset.lastInspectionDate">
                        <span class="inspection-label me-1">{{ 'asset.lastInspection' | translate }}:</span>
                        <span class="inspection-label fw-bold">{{ asset.lastInspectionDate | localizedDate }}</span>
                    </div>
                    <div *ngIf="asset.nextInspectionDate">
                        <span class="inspection-label me-1">{{ 'asset.nextInspection' | translate }}:</span>
                        <span class="inspection-label fw-bold">{{ asset.nextInspectionDate | localizedDate }}</span>
                    </div>
                    <div *ngIf="asset.nextInspectionDate">
                        <span class="inspection-label mobile-label me-1">{{ 'asset.inspectionLink' | translate }}:</span>
                        <span
                            class="inspection-label text-primary mobile-app-link"
                            (click)="openAssetInspectionModal()"
                        >{{ 'asset.mobileApp' | translate }}</span>
                        <span class="inspection-label mobile-label">{{ '.' }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Second part: Asset property cards -->
        <div class="d-flex flex-column gap-4 flex-grow-1">
            <div class="d-flex flex-wrap gap-4 asset-cards-container">
                <ng-container *ngIf="asset.deliveryStatus === AssetDeliveryStatus.ESTIMATED">
                    <div *ngIf="asset?.deliveryLocation" class="asset-header-prop-card ccc asset-card-responsive">
                        <span class="cell-title d-flex justify-content-start">{{ 'asset.deliveryLocation' | translate }}</span>
                        <span HJSupress class="cell-value d-flex justify-content-start">{{ asset.deliveryLocation | replaceIfNull }}</span>
                    </div>
                    <div class="asset-header-prop-card ccc asset-card-responsive">
                        <span class="cell-title d-flex justify-content-start">{{ 'asset.clientDelegate' | translate }}</span>
                        <div *ngIf="asset.deliveryDelegateName" HJSuppress class="cell-value d-flex justify-content-start">
                            <span class="me-1">{{asset?.deliveryDelegateName}}</span>
                            <span class="link-underline-primary-custom" (click)="openDelegateModal(asset)">
                                {{'contractDetail.assets.change' | translate}}
                            </span>
                        </div>
                        <div *ngIf="!asset.deliveryDelegateName" HJSuppress>
                            <span class="link-underline-primary-custom" (click)="openDelegateModal(asset)">
                                {{'contractDetail.assets.addDelegate' | translate}}
                            </span>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="asset?.supplier" class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{ 'asset.Supplier' | translate }}</div>
                    <div HJSuppress class="cell-value d-flex justify-content-start">{{ asset.supplier }}</div>
                </div>
                <div *ngIf="asset?.dictionaryAssetType" class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{ 'asset.Type' | translate }}</div>
                    <div HJSupress class="cell-value d-flex justify-content-start">{{ asset?.dictionaryAssetType.value | replaceIfNull }}</div>
                </div>
                <div class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{'asset.productType' | translate }}</div>
                    <div HJSuppress class="cell-value d-flex justify-content-start">
                        @switch (asset.dictionaryContractType.code) {
                            @case (ContractType.OPERATIONAL_LEASING) {
                                {{'contracts.contractType.operationalLeasing' | translate}}
                            }
                            @case (ContractType.FINANCIAL_LEASING) {
                                {{'contracts.contractType.financialLeasing' | translate}}
                            }
                            @case (ContractType.CREDIT) {
                                {{'contracts.contractType.credit' | translate}}
                            }
                        }
                    </div>
                </div>
                <div *ngIf="asset?.vin" class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{ 'asset.serialNumber' | translate }}</div>
                    <div HJSuppress class="cell-value d-flex justify-content-start">{{ asset.vin }}</div>
                </div>
                <div class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{ 'asset.contractNumber' | translate }}</div>
                    <div HJSupress class="cell-value d-flex justify-content-start">
                        <span class="link-underline-primary-custom" (click)="navigateToContractHandler(asset.contractExternalEntityId)">
                            {{ asset.contractNumber }}
                        </span>
                    </div>
                </div>
                <div class="asset-header-prop-card ccc asset-card-responsive">
                    <div class="cell-title d-flex justify-content-start">{{ 'asset.Value' | translate }}</div>
                    <div HJSupress class="cell-value d-flex justify-content-start">{{ asset.value }} {{asset.currency}}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Asset Journey -->
    <div *ngIf="dataLoaded" class="d-flex flex-column">
        <!-- Asset Delivery -->
        <div *ngIf="asset?.assetDelivery" class="d-flex gap-3 mb-1">
            <div class="d-flex flex-column align-items-center justify-content-start gap-1 flex-shrink-0">
                <i class="app-icon icon icon-check-circle-fill icon-xxl text-primary"></i>
                <div *ngIf="asset?.inspections?.length > 0 || (!asset?.isContractActive && asset?.contractTerminationDate)" class="vr-divider"></div>
            </div>

            <div class="d-flex flex-column gap-3 mb-4 flex-grow-1">
                <div class="text-primary journey-step-title">
                    {{'asset.assetDelivery' | translate}}
                </div>
                <div class="journey-step-card ccc d-flex flex-column gap-3">
                    <div class="row">
                        <div id="ClientName" class="col-lg-3 prop-card">
                            <div class="cell-title">{{ 'asset.clientName' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.assetDelivery?.clientName }}</div>
                        </div>
                        <div id="DeliveryDate" class="col-lg-3 prop-card">
                            <div class="cell-title">{{'asset.deliveryDate' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.assetDelivery?.deliveryDate | localizedDate:'short' }}</div>
                        </div>
                        <div id="DeliveryLocation" class="col-lg-3 prop-card">
                            <div class="cell-title">{{'asset.deliveryLocation' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.assetDelivery?.locationName }}</div>
                        </div>
                        <div id="DealerName" class="col-lg-3 prop-card">
                            <div class="cell-title">{{ 'asset.dealerName' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.assetDelivery?.dealerName }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div id="Condition" class="col-lg-3 prop-card">
                            <div class="cell-title">{{'asset.Condition' | translate}}</div>
                            <div HJSuppress class="cell-value">
                                <div>
                                    {{ asset.condition ?  ('asset.conditionSh'| translate) : ('asset.conditionNew' | translate) }}
                                </div>
                            </div>
                        </div>
                        <div *ngIf="asset?.manufactureYear" id="ManufactureYear" class="col-lg-3 prop-card">
                            <div class="cell-title">{{'asset.ManufactureYear' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.manufactureYear }}</div>
                        </div>
                        <div *ngIf="asset?.assetDelivery?.hotoProtocolDocument" id="HotoProtocol" class="col-lg-3 prop-card">
                            <div class="cell-title">{{ 'asset.hotoProtocol' | translate}}</div>
                            <div HJSuppress class="cell-value d-flex gap-2">
                                {{ asset?.assetDelivery?.hotoProtocolDocument?.documentName }}
                                <i  class="app-icon icon icon-download icon-xl cursor-pointer"
                                    (click)="downloadDocument(asset?.assetDelivery?.hotoProtocolDocument)">
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Asset Inspections -->
        <div *ngIf="asset?.inspections" class="d-flex flex-column mb-1">
            <div *ngFor="let inspection of asset.inspections; let isLast = last" class="d-flex gap-3 w-100 mb-1">
                <div class="d-flex flex-column align-items-center gap-1 flex-shrink-0">
                    <i class="app-icon icon icon-check-circle-fill icon-xxl text-primary"></i>
                    <div *ngIf="!isLast || (!asset?.isContractActive && asset?.contractTerminationDate)" class="vr-divider d-flex"></div>
                </div>

                <div class="d-flex flex-column gap-3 flex-grow-1" [ngClass]="{ 'mb-4': isLast }">
                    <div class="text-primary journey-step-title">
                        {{ 'asset.assetInspection' | translate}}
                    </div>
                    <div class="journey-step-card ccc d-flex flex-column gap-3">
                        <div class="row">
                            <div id="InspectedBy" class="col-lg-3">
                                <div class="cell-title">{{ 'asset.inspectedBy' | translate}}</div>
                                <div HJSuppress class="cell-value">{{ inspection.inspectorName }}</div>
                            </div>
                            <div id="Date" class="col-lg-3">
                                <div class="cell-title">{{ 'asset.date' | translate}}</div>
                                <div HJSuppress class="cell-value">{{ inspection.inspectionDate | localizedDate:'short' }}</div>
                            </div>
                            <div id="Location" class="col-lg-3">
                                <div class="cell-title">{{ 'asset.location' | translate}}</div>
                                <div class="cell-value d-flex align-items-center gap-2">
                                    <i class="app-icon icon icon-location-pin text-primary"></i>
                                    <span HJSuppress class="link-underline-primary-custom" (click)="openGoogleMaps(inspection.latitude, inspection.longitude)">{{ 'See Location' | translate }}</span>
                                </div>
                            </div>
                            <div *ngIf="inspection.assetInspectionReportDocument" id="AssetInspectionReport" class="col-lg-3">
                                <div class="cell-title">{{ 'asset.inspectionReport' | translate}}</div>
                                <div HJSuppress class="cell-value d-flex align-items-center gap-2">
                                    {{ inspection.assetInspectionReportDocument?.documentName }}
                                    <i  class="app-icon icon icon-download icon-xl cursor-pointer"
                                        (click)="downloadDocument(inspection.assetInspectionReportDocument)">
                                    </i>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div *ngIf="inspection.inspectionPhotos" id="AssetInspectionReport" class="col-lg-3">
                                <div class="cell-title">{{ 'asset.inspectionPhotos' | translate}}</div>
                                <div HJSuppress class="cell-value d-flex align-items-center gap-2">
                                    <ng-container *ngFor="let photo of inspection.inspectionPhotos">
                                        <img HJSuppress
                                             [src]="path+'/getStoredFile?fileName='+photo+'&access_token='+accesToken+'&appId='+appId"
                                             alt="Issue Photo" class="img-fluid img-issue" (click)="downloadPhoto(photo)" />
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Contract Ending -->
        <div *ngIf="!asset?.isContractActive && asset?.contractTerminationDate" class="d-flex gap-3">
            <div class="d-flex flex-column align-items-center flex-shrink-0">
                <i class="app-icon icon icon-check-circle-fill icon-xxl text-primary"></i>
            </div>

            <div class="d-flex flex-column gap-3 flex-grow-1">
                <div class="text-primary journey-step-title">
                    {{ 'asset.contractEnding' | translate}}
                </div>
                <div class="journey-step-card ccc d-flex flex-column gap-3">
                    <div class="row">
                        <div id="TerminationDate" class="col-lg-3">
                            <div class="cell-title">{{ 'asset.date' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.contractTerminationDate | localizedDate }}</div>
                        </div>
                        <div *ngIf="asset?.contractTerminationReason" id="TerminationReason" class="col-lg-3">
                            <div class="cell-title">{{ 'asset.reason' | translate}}</div>
                            <div HJSuppress class="cell-value">{{ asset?.contractTerminationReason }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #warningMessagesTemplate>
    <ul class="text-start ps-4 m-0">
        <li *ngFor="let message of requestAccessWarnings" [innerHtml]="message | translate"></li>
    </ul>
</ng-template>

